export default __webpack_public_path__ + "images/graphics/car-scale-animation.svg";